import { render, staticRenderFns } from "./MtmLogin.vue?vue&type=template&id=08c5dd46&scoped=true&"
import script from "./MtmLogin.vue?vue&type=script&lang=js&"
export * from "./MtmLogin.vue?vue&type=script&lang=js&"
import style0 from "./MtmLogin.vue?vue&type=style&index=0&id=08c5dd46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c5dd46",
  null
  
)

export default component.exports